class PaletteState {
  open = $state(false);
}

class ShortcutsHelpState {
  open = $state(false);
}

export const paletteState = new PaletteState();
export const shortcutsHelpState = new ShortcutsHelpState();
